// extracted by mini-css-extract-plugin
module.exports = {"icon":"ColorCheckboxRow_icon__1YnaE","iconChecked":"ColorCheckboxRow_iconChecked__H29p5"};